export const isEmpty = (value: any): boolean => {
  const isEmptyObject = (a: Record<string, any> | any[]): boolean => {
    if (!Array.isArray(a)) {
      // it's an Object, not an Array
      // Object is empty if it has no keys
      return Object.keys(a).length === 0;
    }

    // Array is empty if it has no elements that are not empty
    return !a.some(function nonEmpty(element: any) {
      return !isEmpty(element); // at least one element should be non-empty
    });
  };
  return (
    value === undefined || value === null || (typeof value === 'object' && isEmptyObject(value))
  );
};
